import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SmsBlacklistFilter} from "./smsBlacklistFilter";
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'micro-smsBlacklist',
  templateUrl: './smsBlacklist.component.html'
})
export class SmsBlacklistComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SmsBlacklistFilter = new SmsBlacklistFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || 20))
      ;

    this.http.get(`${this.env.e.url}/sms/blacklist`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }

  isAfterNow(date) {
    if (typeof date !== typeof Date) {
      date = new Date(date);
    }
    return date.getTime() > (new Date()).getTime();
  }
  isBeforeNow(date) {
    if (typeof date !== typeof Date) {
      date = new Date(date);
    }
    return date.getTime() < (new Date()).getTime();
  }
}
